import axios from "axios";
import {
  ScheduleCancelFulfillRequest,
  ScheduleCancelFulfillResponse,
} from "redmond";
import { config } from "../../config";
import { getActivitiesCancelFulfillSchedulePath } from "../paths";

export const getActivitiesCancelFulfillSchedule = async (
  req: ScheduleCancelFulfillRequest
): Promise<ScheduleCancelFulfillResponse> => {
  const res = await axios.post(getActivitiesCancelFulfillSchedulePath, req, {
    baseURL: config.baseURL,
  });

  return res.data;
};
